<ng-container *ngIf="formRef?.control as formRefControl">
  <h1 class="formSection__header">Transport Information</h1>
  <form [formGroup]="formRefControl" class="cmn-forms transportInfo">
    <div class="formGrid__esvr formGrid__esvr--split">
      <div class="formSection__input hauler">
        <h2 class="input__title">Hauler</h2>
        <div *ngIf="editing; else elseHauler">
          <mat-form-field floatLabel="never">
            <input
              type="text"
              matInput
              [matAutocomplete]="haulerAuto"
              [formControl]="haulerControl"
              #haulerTrigger="matAutocompleteTrigger"
              (click)="resetHaulerSelect(haulerTrigger)"
            />
            <mat-autocomplete #haulerAuto="matAutocomplete" [displayWith]="displayHauler" (closed)="updateHaulerSelect()">
              <mat-option *ngFor="let option of filteredHaulerOptions" [value]="option" (click)="chooseHauler(option)">
                {{ option.name }}
              </mat-option>
              <mat-option [value]="OtherOption" (click)="chooseHauler(OtherOption)">Other</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="submited && !showOther.hauler">{{ $any(formRefControl).controls.hauler.errors | formError }}</mat-error>
          </mat-form-field>
          <ng-container *ngIf="showOther.hauler">
            <mat-form-field floatLabel="never" class="light-text-input">
              <input matInput type="text" formControlName="hauler" />
              <mat-error *ngIf="submited && showOther.hauler">{{ $any(formRefControl).controls.hauler.errors | formError }}</mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <ng-template #elseHauler>
          <p class="transportInfo-readonly">{{ getFieldValue('hauler') }}</p>
        </ng-template>
      </div>
      <div class="formSection__input vehicleType">
        <h2 class="input__title">Vehicle Type</h2>
        <div *ngIf="editing; else elseVehicleType">
          <mat-form-field floatLabel="never">
            <mat-select formControlName="vehicleType">
              <mat-option *ngFor="let type of vehicleTypeFormArray" [value]="type.value" (click)="chooseVehicleType(type.value)">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="submited">{{ $any(formRefControl).controls.vehicleType.errors | formError }}</mat-error>
          </mat-form-field>
          <ng-container *ngIf="false">
            <mat-form-field floatLabel="never" class="light-text-input">
              <input matInput type="text" [value]="haulerMapper.getLabel($any(formRefControl).controls.vehicleType.value)" />
            </mat-form-field>
          </ng-container>
        </div>
        <ng-template #elseVehicleType>
          <p class="transportInfo-readonly">{{ getFieldValue('vehicleType') }}</p>
        </ng-template>
      </div>
    </div>
    <div class="formGrid__esvr formGrid__esvr--split">
      <div class="formSection__input truck#">
        <h2 class="input__title">Vehicle ID</h2>
        <div *ngIf="editing; else elseVehicleId">
          <mat-form-field floatLabel="never">
            <mat-label *ngIf="showOther.vehicleId">Other</mat-label>
            <mat-select formControlName="truckNumber" #vn>
              <mat-option
                *ngFor="let option of truckLists"
                [value]="option.truckNumber"
                (click)="populateField(PopulateFields.TruckPlate, option)"
              >
                {{ option.truckNumber }}
              </mat-option>
              <mat-option *ngIf="!showOther.vehicleId" (click)="showOther.vehicleId = true; markAsPrestine()">Other </mat-option>
            </mat-select>
            <mat-error *ngIf="submited && !showOther.vehicleId">
              {{ $any(formRefControl).controls.truckNumber.errors | formError }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="showOther.vehicleId">
            <mat-form-field floatLabel="never" class="light-text-input">
              <input matInput type="text" formControlName="truckNumber" />
              <mat-error *ngIf="submited && showOther.vehicleId">
                {{ $any(formRefControl).controls.truckNumber.errors | formError }}
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <ng-template #elseVehicleId>
          <p>{{ getFieldValue('truckNumber') }}</p>
        </ng-template>
      </div>
      <div class="formSection__input plate#">
        <h2 class="input__title">Plate#</h2>
        <div *ngIf="editing; else elseVehiclePlate">
          <mat-form-field floatLabel="never">
            <mat-label *ngIf="showOther.vehiclePlate">Other</mat-label>
            <mat-select formControlName="vehiclePlate" #vp>
              <mat-option
                *ngFor="let option of truckLists"
                [value]="option.vehiclePlate"
                (click)="populateField(PopulateFields.TruckNumber, option)"
              >
                {{ option.vehiclePlate }}
              </mat-option>
              <mat-option *ngIf="!showOther.vehiclePlate" (click)="showOther.vehiclePlate = true; markAsPrestine()"> Other</mat-option>
            </mat-select>
            <mat-error *ngIf="submited && !showOther.vehiclePlate">
              {{ $any(formRefControl).controls.vehiclePlate.errors | formError }}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="showOther.vehiclePlate">
            <mat-form-field floatLabel="never" class="light-text-input">
              <input matInput type="text" formControlName="vehiclePlate" />
              <mat-error *ngIf="submited && showOther.vehiclePlate">
                {{ $any(formRefControl).controls.truckNumber.errors | formError }}
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <ng-template #elseVehiclePlate>
          <p class="transportInfo-readonly">{{ getFieldValue('vehiclePlate') }}</p>
        </ng-template>
      </div>
    </div>
    <div class="formSection__input driverName">
      <h2 class="input__title">Driver Name</h2>
      <div *ngIf="editing; else elseDriver">
        <mat-form-field class="light-text-input" floatLabel="never">
          <input matInput type="text" formControlName="driver" [value]="" />
        </mat-form-field>
        <mat-error *ngIf="submited && $any(formRefControl).get('driver').touched">
          {{ $any(formRefControl).controls.driver.errors | formError }}
        </mat-error>
      </div>
      <ng-template #elseDriver>
        <p class="transportInfo-readonly">{{ getFieldValue('driver') }}</p>
      </ng-template>
    </div>
  </form>
</ng-container>
